// extracted by mini-css-extract-plugin
export default {"nonTakenSmall":"NonTakenOptions_nonTakenSmall__rLTz+","smallText":"NonTakenOptions_smallText__-rPcW","nonTakenOptions":"NonTakenOptions_nonTakenOptions__jznt9"};